import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'
import { AnalysisResultModal } from './AnalysisResultModal.component'

const withUnmountHoc = withUnmountTransition(AnalysisResultModal)
export { withUnmountHoc as AnalysisResultModal }
